"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var employee_1 = require("./employee/employee");
require("./employee-level.scss");
var EmployeeLevel = (function (_super) {
    __extends(EmployeeLevel, _super);
    function EmployeeLevel(props) {
        var _this = _super.call(this, props) || this;
        Object.defineProperty(_this, "useMaxRows", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        mobx_1.makeObservable(_this);
        _this.renderEmployee = _this.renderEmployee.bind(_this);
        _this.renderEmployees = _this.renderEmployees.bind(_this);
        _this.toggleUseMaxRows = _this.toggleUseMaxRows.bind(_this);
        _this.sortEmployees = _this.sortEmployees.bind(_this);
        return _this;
    }
    Object.defineProperty(EmployeeLevel.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var className = this.props.className;
            var employeeLevelClasses = "employee-level " + className;
            var focusedEmployee = this.props.employees.find(function (employee) { return employee.isFocused; });
            if (!focusedEmployee) {
                return (React.createElement("div", { className: employeeLevelClasses },
                    this.renderEmployees(),
                    this.renderShowMoreButton()));
            }
            return (React.createElement("div", { className: employeeLevelClasses }, this.renderEmployee(focusedEmployee)));
        }
    });
    Object.defineProperty(EmployeeLevel.prototype, "renderEmployees", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var unfocusedEmployees = this.props.employees.filter(function (employee) { return employee.isFocused === false; });
            var sortedEmployees = unfocusedEmployees.sort(this.sortEmployees);
            if (this.useMaxRows) {
                var numberOfHiddenEmployees = this.props.employees.length - this.props.maxRowsPerLevel;
                var numberOfFocusedEmployees = this.props.employees.length - unfocusedEmployees.length;
                sortedEmployees.splice(this.props.maxRowsPerLevel - numberOfFocusedEmployees, numberOfHiddenEmployees);
            }
            return sortedEmployees.map(this.renderEmployee);
        }
    });
    Object.defineProperty(EmployeeLevel.prototype, "renderEmployee", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (employee) {
            var _a = this.props, onEmployeeClick = _a.onEmployeeClick, onViewEmployee = _a.onViewEmployee;
            if (!employee.employeeSourceId) {
                return null;
            }
            return (React.createElement(employee_1.default, { store: this.props.store, key: employee.employeeSourceId, employee: employee, onClick: onEmployeeClick, onView: onViewEmployee }));
        }
    });
    Object.defineProperty(EmployeeLevel.prototype, "renderShowMoreButton", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a = this.props, employees = _a.employees, maxRowsPerLevel = _a.maxRowsPerLevel;
            if (employees.length <= maxRowsPerLevel) {
                return null;
            }
            if (this.useMaxRows === false) {
                return (React.createElement("a", { className: "pxl-btn pxl-btn--sm", style: { pointerEvents: 'auto' }, onClick: this.toggleUseMaxRows }, "Show Less"));
            }
            return (React.createElement("a", { className: "pxl-btn pxl-btn--sm", style: { pointerEvents: 'auto' }, onClick: this.toggleUseMaxRows }, "Show More"));
        }
    });
    Object.defineProperty(EmployeeLevel.prototype, "toggleUseMaxRows", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.useMaxRows = !this.useMaxRows;
        }
    });
    Object.defineProperty(EmployeeLevel.prototype, "sortEmployees", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (employee, nextEmployee) {
            return employee.getFormattedName(this.props.employeeSortFormat)
                .localeCompare(nextEmployee.getFormattedName(this.props.employeeSortFormat));
        }
    });
    __decorate([
        mobx_1.observable
    ], EmployeeLevel.prototype, "useMaxRows", void 0);
    return EmployeeLevel;
}(React.Component));
exports.EmployeeLevel = EmployeeLevel;
exports.default = mobx_react_1.observer(EmployeeLevel);
